import React from "react";
import Show from "../../../../../utils/show.component";
import StylizedRadioGroup from "../../../misc/stylized-radio-group.component";

export const RecurringOpenEndType = (props) => {
  return (
    <div>
      <div className="mb-3">
        <StylizedRadioGroup
          title="Choose Payment Method"
          subtitle="You will pay this amount each month."
          fieldGroupName="OpenEndPaymentType"
          radioOptions={[
            {
              label: (
                <div>
                  <div>Minimum Amount Due</div>
                  <div className="f12">Pay the minimum amount due each month.</div>
                </div>
              ),
              id: "minimumAmountDue",
              value: "Minimum Amount Due",
            },
            {
              label: (
                <div>
                  <div>Total Balance</div>
                  <div className="f12">Pay the the entire loan balance each month</div>
                </div>
              ),
              id: "totalBalance",
              value: "Total Balance",
            },
          ]}
          thisForm={props.thisForm}
          change={props.change}
        />
        <Show condition={props.isFixedAmount}>
          <StylizedRadioGroup
            fieldGroupName="OpenEndPaymentType"
            radioOptions={[
              {
                label: (
                  <div>
                    <div>Fixed Amount</div>
                    <div className="f12">Pay this amount each month.</div>
                  </div>
                ),
                id: "fixedAmount",
                value: "Fixed Amount",
              },
            ]}
            thisForm={props.thisForm}
            change={props.change}
          />
        </Show>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/authenticated-payments/payment-forms/field-components/recurring-fields/recurring-open-end-type.component.js